import SelfPayPage from "./SelfPayPage";

export default SelfPayPage;
